import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import AcademiaButton from '../CommonComps/Buttons/AcademiaButton';
import CreateEditPackageModal from '../CommonComps/Modals/CreateEditPackageModal';

const CreatePackageAction = ({
  hasCreatePermission,
}: {
  hasCreatePermission: boolean;
}) => {
  // integration of react hooks here
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false);

  // rendering create package action component here
  return (
    <div>
      <AcademiaButton
        title={
          !hasCreatePermission ? 'You do not have permissions!' : undefined
        }
        type='button'
        variant='info'
        onClick={() => setShowCreateModal(true)}
        icon={<TbSquareRoundedPlusFilled className='size-6' />}
        isDisabled={!hasCreatePermission}
      >
        Create Package
      </AcademiaButton>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showCreateModal && (
          <CreateEditPackageModal
            title='create'
            handleModalClose={() => setShowCreateModal(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default CreatePackageAction;
